import {useEffect} from "react";
import {Sparks} from "../../utils/Sparks.js";
import forgeFireAudio from "../../audio/forge-fire.mp3";
import {AnimationUtils} from "../../utils/AnimationUtils.js";
import { ReactComponent as ForgeLogoAnim } from "../../images/logos/forge-logo-anim.svg";

export default function Intro()
{
    useEffect(() =>
        {
            if (shouldShowLoadingAnimation())
            {
                const logoLoad = new Audio(forgeFireAudio);

                setTimeout(() => logoLoad.play().catch(() => {}), 500);

                setTimeout(() => Sparks.createParticle(), 600);

                setTimeout(() =>
                {
                    document.querySelectorAll(".spark").forEach((el) => { el.classList.add("fade-out"); });

                    setTimeout(() =>
                    {
                        const layers = document.querySelectorAll(".layer");

                        AnimationUtils.transformElement(
                        {
                            element: document.getElementById("intro-screen"),
                            transformation: () =>
                            {
                                layers.forEach((layer, index) =>
                                    { setTimeout(() => layer.style.transform = "translateY(-110vh) scale(1.2)", index * 80); });
                                return layers[layers.length - 1];
                            },
                            hide: true,
                        });
                    }, 800);
                }, 1750);
            }
            else
            {
                const intro = document.getElementById("intro-screen");
                if (intro) intro.classList.add("hidden");
            }
        },
        []);

    return (
        <div id="intro-screen">
            <div className="layer layer-1" id="layer1">
                <ForgeLogoAnim id="intro-logo" className="logo"/>
            </div>
            <div className="layer layer-2" id="layer2"></div>
            <div className="layer layer-3" id="layer3"></div>
            <div className="layer layer-4" id="layer4"></div>
        </div>
    );
};

function shouldShowLoadingAnimation()
{
    if (sessionStorage.getItem("site-visited")) return false;
    sessionStorage.setItem("site-visited", "true");
}